const BASE_URL = process.env.REACT_APP_API_URL;

function authHeader() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// common/api.js 에 추가
export async function signup(email, password) {
  const res = await fetch(`${BASE_URL}/auth/signup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

export async function verifyOtp(email, otp) {
  const res = await fetch(`${BASE_URL}/auth/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp }),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json(); // { token }
}

export async function login(email, password) {
  const res = await fetch(`${BASE_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json(); // { token }
}

export async function resendOtp(email) {
  const res = await fetch(`${BASE_URL}/auth/resend-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

export async function fetchTours(date) {
  const query = date ? `?date=${date}` : "";
  const res = await fetch(`${BASE_URL}/tours${query}`);
  if (!res.ok) throw new Error("Failed to fetch tours");
  return res.json();
}

export async function fetchTour(tourId) {
  const res = await fetch(`${BASE_URL}/tours/${tourId}`);
  if (!res.ok) throw new Error("Failed to fetch tour");
  return res.json();
}

export async function getTourDetail(tourId, date) {
  const res = await fetch(`${BASE_URL}/tours/${tourId}/detail?date=${date}`);
  if (!res.ok) throw new Error("Failed to fetch tour detail");
  return res.json();
}

export async function createBooking(data) {
  const res = await fetch(`${BASE_URL}/bookings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),  // 추가
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

export async function addCartItem(data) {
  const res = await fetch(`${BASE_URL}/cart`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Failed to add to cart");
  return res.json();
}

export async function fetchCartItems() {
  const res = await fetch(`${BASE_URL}/cart`, {
    headers: authHeader(),
  });
  if (!res.ok) throw new Error("Failed to fetch cart");
  return res.json();
}

export async function deleteCartItem(id) {
  const res = await fetch(`${BASE_URL}/cart/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });
  if (!res.ok) throw new Error("Failed to delete cart item");
  return res.json();
}

// 리뷰 목록
export async function fetchReviews(tourId) {
  const res = await fetch(`${BASE_URL}/reviews/${tourId}`);
  if (!res.ok) throw new Error("Failed to fetch reviews");
  return res.json(); // { reviews, avgRating }
}

// 리뷰 작성
export async function createReview(data) {
  const res = await fetch(`${BASE_URL}/reviews`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

// 리뷰 수정
export async function updateReview(id, data) {
  const res = await fetch(`${BASE_URL}/reviews/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

// 리뷰 삭제
export async function deleteReview(id) {
  const res = await fetch(`${BASE_URL}/reviews/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

// 대댓글 작성
export async function createReply(reviewId, content) {
  const res = await fetch(`${BASE_URL}/reviews/${reviewId}/replies`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify({ content }),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

// 대댓글 삭제
export async function deleteReply(id) {
  const res = await fetch(`${BASE_URL}/reviews/replies/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });
  if (!res.ok) throw new Error((await res.json()).message);
  return res.json();
}

export async function fetchAllReviews(offset = 0, limit = 5) {
  const res = await fetch(`${BASE_URL}/reviews?offset=${offset}&limit=${limit}`);
  if (!res.ok) throw new Error("Failed to fetch reviews");
  return res.json();
}